import React from 'react'
import ReactMarkdown from 'react-markdown'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import theme from 'theme'

import { ActionStripMobile } from '../ActionStripMobile'
import {
  CryptoInterstitalProps,
  STRING_PREFIX,
  ValueProp,
} from './CryptoInterstitial'
import { MobileButton } from './MobileButton'
import {
  Body,
  BodyHeader,
  Container,
  MarkdownStyler,
  StyledLogo,
  TextContainer,
  Title,
  ValuePropContainer,
} from './styled-components'

export const CryptoLanderMobile: React.FC<CryptoInterstitalProps> = ({
  onBack,
  cta,
  header1,
  header2,
  icons,
  imageUrl,
  title,
  toggleModal,
  value_prop1,
  value_prop2,
  value_prop3,
  ...props
}) => {
  const { StyledRemoteString } = useRemoteStrings()

  return (
    <>
      <Container>
        <ActionStripMobile
          handleBackPress={onBack}
          handleClosePress={onBack}
          closeButton={AcornsIcon.Icon.CloseXIconWhite}
          backgroundColor={theme.colors.greenDark}
        />
        <StyledLogo src={imageUrl} />
        <TextContainer>
          <Title>{title}</Title>
          <ValuePropContainer>
            {[value_prop1, value_prop2, value_prop3].map((prop, index) => (
              <ValueProp
                iconName={icons[index]}
                copy={prop}
                key={`${prop}${index}`}
              />
            ))}
          </ValuePropContainer>
          <BodyHeader>{header1}</BodyHeader>
          <Body>
            <StyledRemoteString
              stringKey={`${STRING_PREFIX}body1`}
              modifiers={[{ bold: 600 }]}
            />
          </Body>
          <BodyHeader>{header2}</BodyHeader>
          <Body>
            <StyledRemoteString
              stringKey={`${STRING_PREFIX}body2.markdown`}
              modifiers={[
                { bold: 600 },
                { bold: 600 },
                { bold: 600 },
                { bold: 600 },
                { bold: 600 },
              ]}
              wrappers={[
                { component: MarkdownStyler },
                { component: MarkdownStyler },
                { component: MarkdownStyler },
                { component: MarkdownStyler },
                { component: MarkdownStyler },
              ]}
            />
            <ReactMarkdown
              source={props['disclosure.link.markdown']}
              linkTarget={'_blank'}
              className="disclosure-markdown"
              escapeHtml={false}
            />
          </Body>
        </TextContainer>
        <MobileButton
          text={cta}
          onPress={() => props.onAddPortfolioPress(toggleModal)}
          secondary
          backgroundColor={theme.colors.greenDark}
        />
      </Container>
    </>
  )
}
